import { SVGProps } from 'react';

export const DefaultReportIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 512 512"
    fill="none"
    role="img"
    aria-label="Default report icon"
    {...props}
  >
    <circle cx="256" cy="256" r="240" fill="#5A6570" />
    <g stroke="white" strokeWidth="20" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <rect x="145" y="145" width="90" height="90" rx="18" />
      <rect x="277" y="145" width="90" height="90" rx="18" />
      <rect x="145" y="277" width="90" height="90" rx="18" />
      <rect x="277" y="277" width="90" height="90" rx="18" />
    </g>
  </svg>
);
